// ABOUTME: Route for /skills/:skillId — fullscreen editor for editing a skill.
import { SkillEditorPage } from "@/components/skills/SkillEditorPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/skills/$skillId")({
  component: EditSkillRoute,
});

function EditSkillRoute() {
  const { skillId } = Route.useParams();
  return <SkillEditorPage key={skillId} mode="edit" skillId={skillId} />;
}
